import './js/sentry.js';
import './stimulus_bootstrap.js';
import './app.scss';
import 'summernote/src/styles/bs4/summernote-bs4.scss';
import 'bootstrap';
import './js/bootstrap-bridge.js'; // jQuery->BS5 compat for $(el).modal()/.tooltip()/… (DDT-3772)
import 'metismenu';
import 'select2';
import 'bootstrap-maxlength';
import 'bootstrap-touchspin';
import 'bootstrap-timepicker';
import 'daterangepicker';
import 'summernote';
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';
import './js/sidebar';
import './js/password-toggle';
import { editProfile } from './js/edit_profile';
import './js/dismiss-keyboard-on-select';
import $ from 'jquery';

global.$ = $;
global.jQuery = $;

// Safety net: the anti-FOUC `body.loading` class is normally removed by the
// sidebar/preloader init. Guarantee removal even if that init doesn't complete,
// so the page is never left invisible (BS5 migration — DDT-3772).
const removeLoadingClass = () => document.body && document.body.classList.remove('loading');
removeLoadingClass();
window.addEventListener('DOMContentLoaded', removeLoadingClass);
window.addEventListener('load', removeLoadingClass);

require('./js/datepicker.js');
require('./images/mail_sent.svg');
require('./images/startman.svg');

function showPreloader() {
    $('#preloader').show();
    $('#status').show();
}

function hidePreloader() {
    $('#preloader').fadeOut('slow');
}

function addAlert(type, message, title = null, duration = 3000) {
    const $alert = $(`
        <div
            class="alert alert-${type} alert-dismissible bg-${type} text-white border-0 fade show mb-0"
            role="alert"
        >
            <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            ${title ? `<strong>${title}</strong>` : ''}
            ${message}
        </div>
    `);

    const $alertContainer = $('.fixed-bottom');

    $alertContainer.find('.alert').remove();
    $alertContainer.append($alert);

    setTimeout(function() {
        if ($alert.length) {
            $alert.find('.close').click();
        }
    }, duration);
}

window.showPreloader = showPreloader;
window.hidePreloader = hidePreloader;
window.addAlert = addAlert;

function contactCustomerServiceModal() {
    const $contactCustomerServiceModal = $('#contact-customer-service-modal');
    const $contactCustomerServiceReasonInput = $('#contact-customer-service-reason-input');
    const $contactCustomerServiceDescriptionInput = $('#contact-customer-service-description-input');
    const $contactCustomerServiceSubmitButton = $('#contact-customer-service-submit-button');
    const $contactCustomerServiceFileInput = $('#contact-customer-service-file-input');

    $contactCustomerServiceSubmitButton.on('click', function(event) {
        event.preventDefault();

        $contactCustomerServiceModal.find('.is-invalid').removeClass('is-invalid');

        const reason = $contactCustomerServiceReasonInput.val();
        const description = $contactCustomerServiceDescriptionInput.val();
        const files = $contactCustomerServiceFileInput[0].files;
        const formData = new FormData();

        if (!reason) {
            $contactCustomerServiceReasonInput.addClass('is-invalid');
        }

        if (!description) {
            $contactCustomerServiceDescriptionInput.addClass('is-invalid');
        }

        if ($contactCustomerServiceModal.find('.is-invalid').length > 0) {
            return;
        }

        formData.append('description', description);
        formData.append('reason', reason);

        if (files && files.length) {
            if (!files[0]['type'].match('image/jpeg') && !files[0]['type'].match('image/png') && !files[0]['type'].match('image/gif') && !files[0]['type'].match('application/pdf')) {
                addAlert('danger', translations['profile.Invalid file type.']);

                return;
            }

            formData.append('file', files[0]);
        }

        showPreloader();

        $.ajax({
            url: routes['app_default_contactcustomerservice'],
            type: 'post',
            data: formData,
            contentType: false,
            processData: false,
            success: function(result) {
                if (result.status) {
                    addAlert('success', result.message);

                    $contactCustomerServiceModal.modal('hide');
                } else {
                    addAlert('danger', result.message || translations['profile.An unknown error occurred.']);
                }
            },
            error: function() {
                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        })
            .done(function() {
                hidePreloader();
            });
    });

    $contactCustomerServiceModal.on('hidden.bs.modal', function() {
        $contactCustomerServiceModal.find('.is-invalid').removeClass('is-invalid');
        $contactCustomerServiceReasonInput.val('');
        $contactCustomerServiceDescriptionInput.val('');
        $contactCustomerServiceFileInput.val('');

        document.getElementById('contact-customer-service-reason-input').tomselect.setValue('', true);
    });
}

$(function() {
    // source: where the change was made (DDT-4157), recorded for the BI status log.
    const changeOnlineStatus = async (isOnline, source, dontShowAgain) => {
        showPreloader();

        const field = 'is_online';
        const url = routes['app_profile_edit'];
        const data = {
            field: field,
            value: isOnline ? 'true' : 'false',
            source: source,
        };

        await $.post(url, data, async function(result) {
            if (result.status) {
                // DDT-4157: replaces "is_online | online|offline | Success". The label is
                // "<post_id> | <where>"; GA_EVENT_LABEL starts with the post id.
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'Account',
                        'action': isOnline ? 'onlineconsult_status_on' : 'onlineconsult_status_off',
                        'label': GA_EVENT_LABEL.split(' | ')[0] + ' | ' + source.replace('manual_', ''),
                    },
                });

                if (dontShowAgain) {
                    $.post(routes['app_profile_onlinetogglepopupdontshow'], {}, () => {
                    });
                }

                if (window.refreshPriorityTab) {
                    await window.refreshPriorityTab();
                }

                hidePreloader();
            } else {
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'Account',
                        'action': field + ' | ' + (isOnline ? 'online' : 'offline') + ' | Failure',
                        'label': GA_EVENT_LABEL,
                    },
                });

                updateButtonStyles(!isOnline);
                addAlert('danger', translations['profile.An unknown error occurred.']);
                hidePreloader();
            }
        }).fail(function() {
            dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    'category': 'Account',
                    'action': field + ' | ' + (isOnline ? 'online' : 'offline') + ' | Failure',
                    'label': GA_EVENT_LABEL,
                },
            });

            updateButtonStyles(!isOnline);
            addAlert('danger', translations['profile.An unknown error occurred.']);
            hidePreloader();
        });
    };

    const updateButtonStyles = (isOnline) => {
        const $mainLabel = $('#online-offline-label');
        const $secondaryLabel = $('#for-online-text');

        // The switch is part of the same state as the labels, so it moves with them here.
        // Leaving it to the save request meant the "15 mins free call" text recoloured
        // straight away while the switch stayed off until the request came back.
        $('#online-offline-switch').prop('checked', isOnline);
        $('.menu-container').toggleClass('online-now', isOnline);
        // DDT-4157: lets the service page banner and the go-online pop-up follow the toggle.
        document.dispatchEvent(new CustomEvent('online-status:changed', { detail: { isOnline } }));

        if (isOnline) {
            $mainLabel.text('On')
                .removeClass('justify-content-end')
                .addClass('justify-content-start');
            $secondaryLabel.addClass('text-green').removeClass('text-red');
        } else {
            $mainLabel.text('Off')
                .removeClass('justify-content-start')
                .addClass('justify-content-end');
            $secondaryLabel.removeClass('text-green').addClass('text-red');
        }
    };

    $('#online-offline-switch').on('change', function(event) {
        // Set by the service page banner, which goes through this switch.
        const popupSource = this.dataset.popupSource;
        delete this.dataset.popupSource;

        const dontShowOnlineConsultationPopUp = $('#online-offline-switch').data('popup-dont-show') === 1;
        // Without the pop-up, the change is made where the lawyer clicked.
        const directSource = 'page_banner' === popupSource ? 'manual_page_banner' : 'manual_header';
        event.preventDefault();

        if ($(this).data('freemium')) {
            $(this).prop('checked', !$(this).prop('checked'));

            dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        action: 'account_promo_paidmembership',
                        category: 'Account',
                        label: '',
                    },
                },
            );

            return;
        }

        const checked = $(this).prop('checked');
        if (checked) {
            if ($('#onlineNowModal').length > 0) {
                $.post(routes['app_profile_onlinetogglepopupviewed'], {}, () => {
                });
            }

            if (dontShowOnlineConsultationPopUp) {
                updateButtonStyles(true);
                changeOnlineStatus(true, directSource);
            } else {
                // Nothing is saved until the lawyer confirms in the modal, so put the
                // switch back rather than show an ON state we have not recorded yet.
                $(this).prop('checked', false);
                // DDT-4157: the pop-up is online_status_modal_controller.js.
                document.dispatchEvent(new CustomEvent('online-consultation:open-popup', {
                    detail: { source: popupSource || 'header' },
                }));
            }
        } else {
            updateButtonStyles(false);
            changeOnlineStatus(false, directSource);
        }
    });

    // DDT-4157: confirmed in the go-online pop-up (online_status_modal_controller.js).
    // Opened from the profile card it counts as profile_card, from anywhere else as popup.
    document.addEventListener('online-consultation:confirm', (event) => {
        updateButtonStyles(event.detail.goOnline);
        changeOnlineStatus(
            event.detail.goOnline,
            'profile_card' === event.detail.source ? 'manual_profile_card' : 'manual_popup',
        );
    });

    $(document).ready(function() {
        // Auto NPS pop-up (admin date window) on every country: UK uses the same pop-up since DDT-3736.
        if (
            typeof routes !== 'undefined'
            && routes['app_accountsettings_surveypopupviewed']
        ) {
            $.ajax({
                url: routes['app_accountsettings_surveypopupviewed'],
                success: function(result) {
                    if (result.show_survey) {
                        showPreloader();

                        $('#nps-survey-touchpoint').val('auto');
                        $('#feedback-zohosurvey-modal').modal();

                        dataLayer.push({
                            event: 'dataLayer.gaEvent',
                            gaEvent: {
                                'category': 'Account',
                                'action': 'NPS Impression',
                                'label': GA_EVENT_LABEL,
                            },
                        });

                        hidePreloader();
                    }
                },
            });
        }

        // When opened from the left-menu trigger (has a relatedTarget), mark the touchpoint as "menu".
        $('#feedback-zohosurvey-modal').on('show.bs.modal', function(event) {
            if (event.relatedTarget) {
                $('#nps-survey-touchpoint').val('menu');
            }

            // Reopened after a completed submission: show a fresh form instead of the thank-you block.
            const $form = $('#nps-survey-form');
            if ($form.hasClass('d-none')) {
                const touchpoint = $('#nps-survey-touchpoint').val();
                $form.trigger('reset').removeClass('d-none');
                $('#nps-survey-touchpoint').val(touchpoint);
                $('#nps-survey-score').val('');
                $('.nps-survey-star-btn').removeClass('active').attr('aria-checked', 'false');
                $('#nps-survey-comment-field').addClass('d-none');
                $('#nps-survey-error').addClass('d-none').text('');
                $('#nps-survey-submit').prop('disabled', true);
                $('#nps-survey-thank-you').addClass('d-none');
            }
        });

        // NPS star rating (1-5): fill every star up to the selected one, then reveal the comment
        // field and unlock the submit button (both stay hidden/disabled until a star is picked).
        $('#feedback-zohosurvey-modal').on('click', '.nps-survey-star-btn', function() {
            const score = $(this).data('score');
            $('.nps-survey-star-btn').each(function() {
                $(this).toggleClass('active', $(this).data('score') <= score);
                // Radio semantics: only the picked star is "checked".
                $(this).attr('aria-checked', $(this).data('score') === score ? 'true' : 'false');
            });
            $('#nps-survey-score').val(score);
            $('#nps-survey-comment-field').removeClass('d-none');
            $('#nps-survey-submit').prop('disabled', false);
            $('#nps-survey-error').addClass('d-none').text('');
        });

        // Mobile bottom sheet: drag the handle down to close.
        const $npsDialog = $('#feedback-zohosurvey-modal .nps-survey-dialog');
        let npsDragStartY = null;
        $('#feedback-zohosurvey-modal').on('touchstart', '[data-nps-survey-handle]', function(event) {
            npsDragStartY = event.originalEvent.touches[0].clientY;
            $npsDialog.css('transition', 'none');
        }).on('touchmove', '[data-nps-survey-handle]', function(event) {
            if (npsDragStartY === null) {
                return;
            }
            const delta = Math.max(0, event.originalEvent.touches[0].clientY - npsDragStartY);
            $npsDialog.css('transform', `translateY(${delta}px)`);
        }).on('touchend touchcancel', '[data-nps-survey-handle]', function(event) {
            if (npsDragStartY === null) {
                return;
            }
            const delta = event.originalEvent.changedTouches[0].clientY - npsDragStartY;
            npsDragStartY = null;
            $npsDialog.css({ transition: '', transform: '' });
            if (delta > 80) {
                $('#feedback-zohosurvey-modal').modal('hide');
            }
        });

        // NPS form submission.
        $('#nps-survey-form').on('submit', function(event) {
            event.preventDefault();

            const $form = $(this);
            const $error = $('#nps-survey-error');

            if ($('#nps-survey-score').val() === '') {
                $error.text($form.data('score-required')).removeClass('d-none');

                return;
            }

            const $submit = $('#nps-survey-submit');
            $submit.prop('disabled', true);

            $.post($form.attr('action'), $form.serialize())
                .done(function() {
                    // Thank-you per score (Isaac): text 1-2 vs 3-5, review CTA only for 4-5.
                    const score = parseInt($('#nps-survey-score').val(), 10);
                    const $thankYou = $('#nps-survey-thank-you');
                    $thankYou.find('[data-nps-thanks]').addClass('d-none');
                    $thankYou.find(`[data-nps-thanks="${score <= 2 ? 'low' : 'high'}"]`).removeClass('d-none');
                    $thankYou.find('[data-nps-cta="review"]').toggleClass('d-none', score < 4);

                    $form.addClass('d-none');
                    $thankYou.removeClass('d-none');
                })
                .fail(function(xhr) {
                    const message = (xhr.responseJSON && xhr.responseJSON.message)
                        ? xhr.responseJSON.message
                        : $form.data('generic-error');
                    $error.text(message).removeClass('d-none');
                    $submit.prop('disabled', false);
                });
        });

        // NPS post-submission CTA click: track in GA, keyed by the rating bucket (label = which CTA).
        $('#feedback-zohosurvey-modal').on('click', '.nps-survey-cta', function() {
            const score = parseInt($('#nps-survey-score').val(), 10);

            let action = '3 rating';
            if (score <= 2) {
                action = '1-2 rating';
            } else if (score >= 4) {
                action = '4-5 rating';
            }

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'NPS',
                        'action': action,
                        'label': $(this).data('nps-cta'),
                    },
                });
            }

            // Also record the click in our database (lawyer, button, score, trigger). sendBeacon
            // survives the new tab the button opens; the server builds the label and validates it.
            const clickUrl = $('#nps-survey-thank-you').data('click-url');
            if (clickUrl && navigator.sendBeacon) {
                const data = new FormData();
                data.append('nps_score', score);
                data.append('cta', $(this).data('nps-cta'));
                data.append('touchpoint', $('#nps-survey-touchpoint').val());
                navigator.sendBeacon(clickUrl, data);
            }
        });
    });

    if ($('[data-bs-toggle="password-validation"]').length > 0) {
        const $passwordInput = $('[data-bs-toggle="password-validation"]');

        $passwordInput.on('focus', function() {
            $('#password-requirements').show();
        });

        $passwordInput.keyup(function() {
            const $length = $('.password-length');
            const $number = $('.password-number');
            const $char = $('#password-special-char');
            const $letter = $('#password-letter');

            const lowerCaseLetters = /[a-zA-Z]/g;
            const numbers = /[0-9]/g;
            const specialChar = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/g;

            // Validate length
            if ($passwordInput.val().length >= 8) {
                $length.removeClass('text-danger text-muted');
                $length.addClass('text-success');
            } else {
                $length.removeClass('text-success text-muted');
                $length.addClass('text-danger');
            }

            // Validate lowercase letters
            if ($passwordInput.val().match(lowerCaseLetters)) {
                $letter.removeClass('text-danger text-muted');
                $letter.addClass('text-success');
            } else {
                $letter.removeClass('text-success text-muted');
                $letter.addClass('text-danger');
            }

            // Validate numbers
            if ($passwordInput.val().match(numbers)) {
                $number.removeClass('text-danger text-muted');
                $number.addClass('text-success');
            } else {
                $number.removeClass('text-success text-muted');
                $number.addClass('text-danger');
            }

            // Validate special char
            if ($passwordInput.val().match(specialChar)) {
                $char.removeClass('text-danger text-muted');
                $char.addClass('text-success');
            } else {
                $char.removeClass('text-success text-muted');
                $char.addClass('text-danger');
            }
        });
    }

    contactCustomerServiceModal();

    $('.rating-stars li').on('mouseover', function() {
        var onStar = parseInt($(this).data('value'), 10); // The star currently mouse on

        // Now highlight all the stars that's not after the current hovered star
        $(this).parent().children('li.star').each(function(e) {
            if (e < onStar) {
                $(this).addClass('hover');
            } else {
                $(this).removeClass('hover');
            }
        });

    }).on('mouseout', function() {
        $(this).parent().children('li.star').each(function(e) {
            $(this).removeClass('hover');
        });
    });

    $('.rating-stars li').on('click', function() {
        var onStar = parseInt($(this).data('value'), 10); // The star currently selected
        var stars = $(this).parent().children('li.star');

        for (var i = 0; i < stars.length; i++) {
            $(stars[i]).removeClass('selected');
        }

        for (var i = 0; i < onStar; i++) {
            $(stars[i]).addClass('selected');
        }

        // JUST RESPONSE (Not needed)
        var ratingValue = parseInt($('.rating-stars li.selected').last().data('value'), 10);

        $($(this).closest('.rating-stars').data('rating-input')).val(ratingValue);
    });

    // DDT-4132: the "create an ad" pro-card pop-up uploads the same way, so read the file from the clicked pop-up
    $('#send-lawyer-documents-submit-button, #send-lawyer-documents-ad-submit-button').on('click', function() {
        const files = $(this).closest('.modal').find('input[type="file"]')[0].files;

        if (!FileReader || !files || !files.length) {
            addAlert('danger', translations['support.File is required.']);

            return;
        }

        if (!files[0]['type'].match('image/jpeg') && !files[0]['type'].match('image/png') && !files[0]['type'].match('image/gif') && !files[0]['type'].match('application/pdf')) {
            addAlert('danger', translations['profile.Invalid file type.']);

            return;
        }

        showPreloader();

        const formData = new FormData();

        formData.append('file', files[0]);
        formData.append('description', $('#send-lawyer-documents-description-input').val());

        $.ajax({
            url: routes['app_profile_uploaddocuments'],
            type: 'post',
            data: formData,
            contentType: false,
            processData: false,
            success: function(result) {
                if (result.status) {
                    window.location.reload();
                } else {
                    addAlert('danger', result.message || translations['profile.An unknown error occurred.']);
                    hidePreloader();
                }
            },
            error: function() {
                addAlert('danger', translations['profile.An unknown error occurred.']);

                hidePreloader();
            },
        });
    });

    let headerPlusStatusHeight = $('.status-container').outerHeight() + $('.navbar-custom').outerHeight() + 24;

    if ($('#documents-container')) {
        $('#documents-container').css('height', 'calc(var(--vh, 1vh) * 100 - ' + headerPlusStatusHeight + 'px)');
    }

    if ($('#litigants-container')) {
        $('#litigants-container').css('height', 'calc(var(--vh, 1vh) * 100 - ' + headerPlusStatusHeight + 'px)');
    }

    // The Hyper theme's hyper.js initialised every tooltip on the page; Bootstrap 5 never
    // initialises tooltips by itself, so without this the static ones (document status on
    // Payments, the Justifit Plus legal-aid lock, ...) stopped showing (DDT-3772). Pages that
    // initialise their own tooltips get the same instance back.
    $('[data-bs-toggle="tooltip"]').tooltip();

    $('[data-bs-toggle="stop-propagation"]').on('click', (event) => {
        event.stopPropagation();
    });

    window.editProfile = editProfile;

    setTimeout(() => {
        let sidebarLogoAndAvailableBannersHeight = $('#sidebar-logo').outerHeight() + ($('.banners-modal').length > 0 ? ($('.banners-modal').outerHeight() * $('.banners-modal').length) : 0);
        $('.simplebar-content-wrapper').css('height', 'calc(var(--vh, 1vh) * 100 - ' + sidebarLogoAndAvailableBannersHeight + 'px)');
    }, 300);
});
